import React, { useRef, useState, useEffect, useCallback } from "react";
import { classNames } from "primereact/utils";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ErrorValidationMessage } from "./ErrorValidationMessage";
import { BrCalendar } from "./BrCalendar";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import "../layout/sass/_form.scss";
import api from "../api/api";

export const FormPrecos = ({ isEditing, isLoading, defaultValues }) => {
    const history = useHistory();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [isContinuar, setIsContinuar] = useState(false);
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const [produtos, setProdutos] = useState(null);

    const schema = Yup.object().shape({
        produtoId: Yup
            .number()
            .required("O produto é obrigatório!")
            .positive("O produto deve ser selecionado!")
            .integer("O produto deve estar na lista"),
        
        data: Yup
            .date()
            // .max(new Date(), "Data é inválida")
            .typeError("Uma data deve ser inserida!")
            .required("A data é obrigatória"),
        valor: Yup
            .string()
            .required("O valor é obrigatório!")
            .max(10, "O valor dete ter no máximo 10 caracteres"),
             });

    const formik = useFormik({

        initialValues : defaultValues,

        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true);
            // data["userEmail"] = user.email
            
            try {
                if (!isEditing) {
                    await api.post("precos", data);
                    formik.setFieldValue("valor", 0.0)
                    toast.current.show({ life: 2000, severity: "success", summary: "Cadastro concluído!", detail: `${data.produtoNome} adicionado(a) com sucesso` });
                    if(isContinuar) {
                        // setTimeout(() => {
                        //     history.push("/precoscreate");
                        // }, 2000);  
                    }else {
                        setTimeout(() => {
                            history.push("/precos");
                        }, 2000);
                    }    
                } else {
                    await api.put("precos", data);
                    toast.current.show({ life: 2000, severity: "success", summary: "Cadastro atualizado!", detail: `${data.produtoNome} atualizado(a) com sucesso` });
                    setTimeout(() => {
                        history.push("/precos");
                    }, 2000);
                }
            } catch (error) {
                if (!isEditing) toast.current.show({ life: 2000, severity: "error", summary: "Erro ao cadastrar preço!", detail: error.response.data });
                else toast.current.show({ life: 2000, severity: "error", summary: "Erro ao editar preço!", detail: error.response.data });
            }

            setIsSubmiting(false);
            setIsContinuar(false);
        },
    });    

    const handleSalvar = () => {    
       setIsContinuar(true);        
       formik.handleSubmit();
       
    }

    const getProdutos = useCallback(async () => {
        
        try {
            const response = await api.get(`produto/listAllProdutoBasic`);  
            setProdutos(response.data.map(produto => {
                let prod = {label: '', value: ''};
                prod.label = produto.nome + " - " + produto.embalagem
                prod.value = produto.id 
                return prod
            }))  
        }
        catch (error) {
            toast.current.show({ life: 2000, severity: "error", summary: "Erro ao buscar produtos!", detail: error.toString() });
        }
    }, []);

    useEffect(() => {
        const precos = async () => {
            await getProdutos();
        }
        precos();

    }, [getProdutos]);

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Preços</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">
                    <div className="p-field p-col-12 p-sm-3 p-md-3">
                            <label htmlFor="data" className={classNames({ 'p-error': isFormFieldValid('data') })}>
                                Data
                            </label>
                            {
                            !isLoading ?
                                <BrCalendar
                                    id="data" 
                                    name="data" 
                                    // disabledDays={[]}  
                                    value={new Date(formik.values.data).toLocaleDateString()} 
                                    onChange={formik.handleChange} 
                                    readonly={true}
                                    placeholder={ isEditing ? new Date(formik.values.data).toLocaleDateString() : new Date().toLocaleDateString()} 
                                    className={classNames({ 'p-invalid': isFormFieldValid('data') })} 
                                    yearRange={`2010:${new Date().getFullYear()+3}`} 
                                /> 
                              : 
                              <Skeleton height="35px" />
                              }
                            {formik.errors.data && formik.touched.data && <ErrorValidationMessage message={formik.errors.data} />}
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label htmlFor="produto" className={classNames({ 'p-error': isFormFieldValid('produto') })}>
                                Produto
                            </label>
                            {!isLoading ? 
                                <Dropdown
                                    id="produtoId"
                                    name="produtoId"
                                    options={produtos}
                                    filter={true}
                                    resetFilterOnHide={true}
                                    emptyMessage={"Nenhum produto encontrado"}
                                    placeholder="Selecione um produto"
                                    className={classNames({ 'p-invalid': isFormFieldValid('produto') })}
                                    value={formik.values.produtoId}
                                    onChange={option => formik.setFieldValue('produtoId', option.value)}
                                    emptyFilterMessage={"Nenhum produto encontrado"}
                                />
                             : 
                                <Skeleton height="35px" />
                            }
                            {formik.errors.produtoId && formik.touched.produtoId && <ErrorValidationMessage message={formik.errors.produtoId} />}
                        </div>
                       
                        <div className="p-field p-col-12 p-sm-4">
                            <label htmlFor="valor" className={classNames({ "p-error": isFormFieldValid("valor") })}>
                                Valor
                            </label>
                            {
                            !isLoading ? 
                                <InputNumber 
                                    id="valor"
                                    name="valor"
                                    mode="currency" minFractionDigits={2} 
                                    currency="BRL"
                                    className={classNames({ 'p-invalid': isFormFieldValid('valor') })}
                                    locale="pt-BR"
                                    value={formik.values.valor}
                                    onChange={(e) => formik.setFieldValue("valor", e.value)}  
                                /> 
                            : 
                            <Skeleton height="35px" />
                            }
                            {formik.errors.valor && formik.touched.valor && <ErrorValidationMessage message={formik.errors.valor} />}
                        </div>
                        
                    </div>
                    <div className="p-d-flex p-jc-end p-mr-1">
                        { !isLoading ? 
                                <>
                                    <Button label={isEditing ? "Atualizar" : "Salvar"} type="submit" iconPos="right" loading={isSubmiting}  style={{marginRight: '10px'}} /> 

                                    {!isEditing ? <Button label="Salvar e continuar" type="button" iconPos="right" loading={isSubmiting} onClick={() => handleSalvar()} />: <></> }
                                    
                                </> 
                            : 
                                <Skeleton width="82.16px" height="35px" />
                        }
                    </div>
                </form>
            </div>
        </div>
    );
};
